import gapi from 'gapi-client';

//const API_KEY = 'AIzaSyDLvhORf-jQJ9FD3DUbRKOFXdB4c8UHKH4';
const API_KEY = 'AIzaSyCLPZI_TfMlQJZeqdF-vjaUlSfk21sZRCg';
//const CLIENT_ID = '31792838525-gavufmg2l6vf7g27pnsbl6l7e48k12qq.apps.googleusercontent.com';
const CLIENT_ID = '1044666903727-l42sim9qlf2ij1jaiqnba99sqq250lr8.apps.googleusercontent.com';
const SCOPE = 'profile https://www.googleapis.com/auth/analytics.readonly';
const DISCOVERY_DOC1 = 'https://analyticsreporting.googleapis.com/$discovery/rest?version=v4';
const DISCOVERY_DOC2 = 'https://www.googleapis.com/discovery/v1/apis/analytics/v3/rest';

export class GoogleService {
	constructor() {
		this.isSignedIn = false;
	}

	load() {
		return new Promise((resolve, reject) => {
			gapi.load('client:auth2', {
				callback: () => {
					console.log('inside load callback');
					resolve(this.initClient());
				},

				onerror: () => {
					console.log('inside load onerror');
					reject('gapi.client failed to load!');
				},

				timeout: 5000,

				ontimeout: () => {
					console.log('inside load ontimeout');
					reject('gapi.client could not load in a timely manner!');
				}
			});
		});
	}

	async initClient() {
		return new Promise((resolve, reject) => {
			console.log('inside0');

			let config = {
				scope: SCOPE,
				client_id: CLIENT_ID,
				response_type: 'id_token permission'
			};

			try {
				gapi.client.load(DISCOVERY_DOC1).then(() => {
					gapi.client.load(DISCOVERY_DOC2).then(() => {
						gapi.auth2.authorize(config, response => {
							if (response.error) {
								console.log('error occued in login.');
								this.isSignedIn = false;
								reject(this.isSignedIn);
							} else {
								var accessToken = response.access_token;
								gapi.auth.setToken(accessToken);
								gapi.client.setApiKey(API_KEY);
								this.isSignedIn = true;
								resolve(this.isSignedIn);
							}
						});
					});
				});
			} catch (error) {
				reject('inside initClient error');
			}
		});
	}

	async login() {
		let resultLoad = await this.load();
		console.log(resultLoad);

		let resultInit = await this.getAccounts();
		console.log(resultInit);
	}

	async getAccounts() {
		try {
			if (!this.isSignedIn) await this.load();

			console.log('inside getAccounts');
			let list = await gapi.client.analytics.management.accounts.list();
			return list;
		} catch (error) {
			console.log('inside getAccounts - error ' + error);
			throw Error(error);
		}
	}

	async getWebProperties(accountId) {
		try {
			if (!this.isSignedIn) await this.load();

			console.log('inside getWebProperties');
			let list = await gapi.client.analytics.management.webproperties.list({
				accountId: accountId
			});
			return list;
		} catch (error) {
			console.log('inside getWebProperties - error ' + error);
			throw Error(error);
		}
	}

	async getProfile(accountId, webPropertyId, profileId) {
		try {
			if (!this.isSignedIn) await this.load();

			console.log('inside getProfile');
			let item = await gapi.client.analytics.management.profiles.get({
				accountId: accountId,
				webPropertyId: webPropertyId,
				profileId: profileId
			});
			return item;
		} catch (error) {
			console.log('inside getProfile - error ' + error);
			throw Error(error);
		}
	}

	async getReport(profileId, startDate, endDate) {
		try {
			if (!this.isSignedIn) await this.load();

			let item = gapi.client.analyticsreporting.reports.batchGet({
				reportRequests: [
					{
						viewId: profileId,
						dateRanges: [{ startDate: startDate, endDate: endDate }],
						metrics: [{ expression: 'ga:sessions', alias: 'Sessions' }],
						dimensions: [{ name: 'ga:year' }, { name: 'ga:month' }]
					}
				]
			});
			return item;
		} catch (error) {
			console.log('inside getReport - error ' + error);
			throw Error(error);
		}
	}
}



// WEBPACK FOOTER //
// ./src/utils/GoogleService.js